<template>
    <v-row>
      <v-col>
<!-- mensaje -->
<transition name="custom-classes-transition" leave-active-class="animated bounceOutRight"> <v-alert dense type="success" v-if="mensaje" class="mensaje" >    {{ text }} </v-alert> </transition>

<v-row>
  <v-col cols="4">
     <pre>{{setreg}}</pre>
  </v-col>
  <v-col cols="4">
     <pre>{{Profesores}}</pre>
  </v-col>
  <v-col cols="4">
      <!-- <pre>{{Alumnos}}</pre> -->
  </v-col>
</v-row>


     &nbsp;&nbsp;
    <v-btn @click="mcrear()" class="primary fluid">Nuevo Registro <v-icon class="ml-1">fa-plus-circle</v-icon></v-btn>
    &nbsp;&nbsp;
    <!-- <v-btn @click="mctabla()" class="primary fluid">Registros <v-icon class="ml-1">fa-plus-circle</v-icon></v-btn>
    &nbsp;&nbsp; -->

    <!--Modal ini -->
<v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title class="error">

            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>

                  <v-col cols="12" sm="6" md="12">
                   Indique motivo del cual desea eliminar este Registro
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
              <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="error"  @click="close">Cancelar</v-btn>

            </v-card-actions>
          </v-card>
</v-dialog>
    <!--Modal end -->

    <!--Registro Anecdotico ini -->
    <v-container v-if="btncrear" fluid grid-list-lg grey lighten-4 >
    <div class="grey lighten-3 ma-10" >
        <v-row class="ma-10">
            <v-col cols="12">
                <h1>Crear Registro Anecdotico</h1>
            </v-col>
            <!-- <v-col cols="3">

                <div v-if="btnallumnos">
                    <v-text-field  label="Otros Alumnos(a)"  maxlength="80" v-model="nombrealumno"  prepend-icon="border-color" required></v-text-field>
                </div>
                <div v-else>
                    <v-text-field  label="Nombre Alumno(a)"  maxlength="80" v-model="nombrealumno"  prepend-icon="border-color" required></v-text-field>
                </div>


            </v-col>
             <v-col cols="3">

                <v-radio-group v-model="btnallumnos" row>
                    <v-radio  label="Si" :value="false"></v-radio>
                    <v-radio  label="No" :value="true"></v-radio>
                </v-radio-group>

            </v-col>
            <v-col cols="6">

            </v-col> -->

            <v-col cols="12">
                <v-row>
                    <v-col cols="4">
                       <v-select
             @change="getAllGradosAdmin(id_nivel)"
            :items="NivelesAdmin"
            v-model="id_nivel"
            item-text="desc_nivel"
            item-value="id_nivel_adm_nivel"
            label="Selecciona el Nivel"
            single-line
            prepend-icon="fa-layer-group"
          ></v-select>
                    </v-col>
                    <v-col cols="4">
                       <v-select
                        @change="getAllSeccionesGrados(id_grado)"
                        :items="GradosAdmin"
                        v-model="id_grado"
                        item-text="desc_grado"
                        item-value="id"
                        label="Selecciona el Grado"
                        single-line
                        prepend-icon="fa-layer-group"
                     ></v-select>
                    </v-col>
                    <v-col cols="4">

                      <v-select
                      @change="alumnos(setreg.id_seccion)"
                        :items="SeccionGrado"
                        v-model="setreg.id_seccion"
                        item-text="nombre_seccion"
                        item-value="id"
                        label="Selecciona el la seccion"
                        single-line
                        prepend-icon="fa-layer-group"
                    ></v-select>
                    </v-col>

                    <!-- -->
                    <v-col cols="12">
                         <v-select
                        :items="Alumnos"
                        v-model="setreg.id_alumno"
                        item-text="nombre_persona"
                        item-value="id"
                        label="Alumno"
                        single-line
                        prepend-icon="fa-user"
                     ></v-select>
                    </v-col>


                     <!-- <v-col cols="3">

                        <v-radio-group v-model="btnallumnos" row>
                            <v-radio  label="Si" :value="false"></v-radio>
                            <v-radio  label="No" :value="true"></v-radio>
                        </v-radio-group>

                     </v-col> -->

                    <!-- -->
                     <v-col cols="4">
                            <!-- data ini -->
                            <template>
                            <v-row>
                            <v-col cols="12" >
                                <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="setreg.fecha_evento"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                >
                                <template v-slot:activator="{ on }"> <!--date -->
                                    <v-text-field
                                    v-model="setreg.fecha_evento"
                                    label="Fecha"
                                    readonly
                                    v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="setreg.fecha_evento" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.menu.save(setreg.fecha_evento)">OK</v-btn>
                                </v-date-picker>
                                </v-menu>
                            </v-col>
                            </v-row>
                            </template>
                            <!-- data end -->
                    </v-col>

                     <v-col cols="4">
                            <!-- hora modal ini -->
                                <template>
                        <v-row>

                            <v-col cols="12" sm="12">
                            <v-dialog
                                ref="dialog"
                                v-model="modal"
                                :return-value.sync="date"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on }"> <!-- start -->
                                <v-text-field
                                    v-model="setreg.hora"
                                    label="Hora"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                                </template>

                        <template>
                            <v-time-picker v-model="setreg.hora" :max="end">
                                <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                            </v-time-picker>
                        </template>

                            </v-dialog>
                            </v-col>
                        </v-row>
                        </template>
                            <!-- hora modal end  -->
                    </v-col>

                    <v-col cols="4">
                        <v-text-field  label="Lugar de Suceso"  maxlength="80" v-model="setreg.lugar_evento"  prepend-icon="border-color" required></v-text-field>
                    </v-col>

                    <!-- -->

                     <v-col cols="6">
                            <v-text-field  label="Docente de Registro"   disabled=""  maxlength="80" v-model="setreg.id_personal_registro"  prepend-icon="border-color" required></v-text-field>
                    </v-col>

                    <v-col cols="6">
                        <!--ini docente encargado -->
                        <v-select v-model="setreg.id_personal_encargado"
                        :items="Profesores"
                        item-text="desc_grado"
                        item-value="id"
                        label="Docente Encargado (curso):"
                        single-line
                        prepend-icon=""
                        ></v-select>
                        <!--end docente encargado -->
                    </v-col>

                    <!-- -->
                    <v-col cols="6">
                        <v-textarea
                        outlined
                        name="input-7-4"
                        label="Descripcion / Comentario"
                        v-model="setreg.descripcion_evento"
                        >
                        </v-textarea>
                    </v-col>

                    <v-col cols="6">
                        <v-textarea
                        outlined
                        name="input-7-4"
                        label="Analisis / Interpretacion"
                        v-model="setreg.analisis_evento"
                        >
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-col>


            <v-col cols="12">
                   <h3>Compartir</h3>
                <v-radio-group v-model="btnmail" row>
                    <v-radio  label="Si" :value="true"></v-radio>
                    <v-radio  label="No" :value="false"></v-radio>
                </v-radio-group>
                <!--Email ini -->
        <div v-if="btnmail">
    <section class="form_wrap">
        <section class="cantact_info">
            <section class="info_title">
                <span class="fa fa-user-circle"></span>
                <!-- <h2>INFORMACION<br>DE CONTACTO</h2> -->
            </section>
            <section class="info_items">
                <p><span class="fa fa-envelope"></span> alberto.vega@clicken1.com</p>
            </section>
        </section>

        <form action="enviar.php" method="post" class="form_contact">
            <h2>Enviar mensaje</h2>
            <div class="user_info">
                <!-- <label for="names">Nombres *</label>
                <input type="text" id="names" name="nombre" required>

                <label for="phone">Telefono / Celular</label>
                <input type="text" id="phone" name="telefono"> -->

                <label for="email" >Correo electronico * </label>
                <input type="text" id="email" name="correo" :rules="nameRules" @keypress="restrictCharsLetras($event)" required>

                <label for="mensaje">Mensaje *</label>
                <textarea id="mensaje" name="mensaje" required></textarea>

                <input type="submit" value="Enviar Mensaje" id="btnSend">
            </div>
        </form>
    </section>
</div>
    <!--Email End -->
            </v-col>
        </v-row>
       <!-- <v-btn class="ma-2" @click="addreganec" color="primary" dark>Agregar <v-icon dark right>fas fa-plus-square</v-icon>  </v-btn> -->

       <v-btn class="ma-2" @click="savereg" color="primary" dark>Agregar <v-icon dark right>fas fa-plus-square</v-icon>  </v-btn>
    </div>
</v-container>
  <!--Registro Anecdotico end -->

    <v-row>
        <v-col cols="12 " class="grey lighten-4">
            <div class="" v-for="(item, index) of reganec" :key="item.id">

      <template>
        <div v-if="editing && variable==index"  >
            <!--adaptando editar ini -->
                   <v-container v-if="btneditar" fluid grid-list-lg grey lighten-4 >
    <div class="grey lighten-3 ma-10" >
        <v-row class="ma-10">
            <v-col cols="12">
                <h1>Editar Registro Anecdotico</h1>
            </v-col>
            <!--mod editar new ini -->

                <v-col cols="12">
                <v-row>
                    <v-col cols="4">
                       <v-select
             @change="getAllGradosAdmin(id_nivel)"
            :items="NivelesAdmin"
            v-model="item.id_nivel"
            item-text="desc_nivel"
            item-value="id_nivel_adm_nivel"
            label="Selecciona el Nivel"
            single-line
            prepend-icon="fa-layer-group"
          ></v-select>
                    </v-col>
                    <v-col cols="4">
                       <v-select
             @change="getAllSeccionesGrados(id_grado)"
            :items="GradosAdmin"
            v-model="item.id_grado"
            item-text="desc_grado"
            item-value="id"
            label="Selecciona el Grado"
            single-line
            prepend-icon="fa-layer-group"
          ></v-select>
                    </v-col>
                    <v-col cols="4">
                      <v-select
            @change="getAllCursosGrados(id_seccion)"
            :items="SeccionGrado"
            v-model="item.id_seccion"
            item-text="nombre_seccion"
            item-value="id"
            label="Selecciona el la seccion"
            single-line
            prepend-icon="fa-user"
          ></v-select>
                    </v-col>

                    <!-- -->
                    <v-col cols="12">
                        <!--search alumnos ini -->
                        <!-- <template>
                        <v-toolbar  dark color="info" >
                            <v-toolbar-title>Buscar Alumnos:</v-toolbar-title>
                            <v-autocomplete autocomplete="off"
                            v-model="item.nomalu"
                            :loading="loading"
                            :items="api1"
                            :search-input.sync="search"
                            cache-items
                            class="mx-4"
                            flat
                            hide-no-data
                            hide-details
                            label="Alumnos:"
                            solo-inverted
                            ></v-autocomplete>
                            <v-btn icon>
                            <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </v-toolbar>
                        </template>  -->
                        <!--search alumnos end -->
                    </v-col>

                     <!-- <v-col cols="3">

                        <v-radio-group v-model="btnallumnos" row>
                            <v-radio  label="Si" :value="false"></v-radio>
                            <v-radio  label="No" :value="true"></v-radio>
                        </v-radio-group>

                     </v-col> -->

                    <!-- -->
                     <v-col cols="4">
                            <!-- data ini -->
                            <template>
                            <v-row>
                            <v-col cols="12" >
                                <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                    v-model="item.date"
                                    label="Fecha"
                                    readonly
                                    v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="date" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                </v-date-picker>
                                </v-menu>
                            </v-col>
                            </v-row>
                            </template>
                            <!-- data end -->
                    </v-col>

                     <v-col cols="4">
                            <!-- hora modal ini -->
                                <template>
                        <v-row>

                            <v-col cols="12" sm="12">
                            <v-dialog
                                ref="dialog"
                                v-model="modal"
                                :return-value.sync="date"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="item.start"
                                    label="Hora"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                                </template>

                        <template>
                            <v-time-picker v-model="start" :max="end">
                                <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                            </v-time-picker>
                        </template>

                            </v-dialog>
                            </v-col>
                        </v-row>
                        </template>
                            <!-- hora modal end  -->
                    </v-col>

                    <v-col cols="4">
                        <v-text-field  label="Lugar de Suceso"  maxlength="80" v-model="item.lugsuc"  prepend-icon="border-color" required></v-text-field>
                    </v-col>

                    <!-- -->

                     <v-col cols="6">
                            <v-text-field  label="Docente de Registro"  maxlength="80" v-model="item.doc"  prepend-icon="border-color" required disabled=""></v-text-field>
                    </v-col>

                    <v-col cols="6">
                                    <!--ini docente encargado -->
                            <v-select v-model="grado"
                            :items="GradosAdmin"
                            item-text="desc_grado"
                            item-value="id"
                            label="Docente Encargado (curso):"
                            persistent-hint
                            single-line
                            prepend-icon=""

                            ></v-select>
                            <!--end docente encargado -->
                    </v-col>

                    <!-- -->

                    <v-col cols="6">
                        <v-textarea
                        outlined
                        name="input-7-4"
                        label="Descripcion / Comentario"
                        v-model="item.descri"
                        >
                        </v-textarea>
                    </v-col>

                    <v-col cols="6">
                        <v-textarea
                        outlined
                        name="input-7-4"
                        label="Analisis / Interpretacion"
                        v-model="item.ana"
                        >
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-col>


            <!--mod editar new end -->
            <!-- <v-col cols="3">

                <div v-if="btnallumnos">
                    <v-text-field  label="Otros Alumnos(a)"  maxlength="80" v-model="item.nomalu"  @keyup.enter="doneEdit()"  @keyup.esc="cancelEdit()"  prepend-icon="border-color" required></v-text-field>
                </div>
                <div v-else>
                    <v-text-field  label="Otros Alumnos(a)"  maxlength="80" v-model="item.nomalu"  @keyup.enter="doneEdit()"  @keyup.esc="cancelEdit()"  prepend-icon="border-color" required></v-text-field>
                </div>

            </v-col>
             <v-col cols="3">

                <v-radio-group v-model="btnallumnos" row>
                    <v-radio  label="Si" :value="false"></v-radio>
                    <v-radio  label="No" :value="true"></v-radio>
                </v-radio-group>

            </v-col>
            <v-col cols="6">

            </v-col>
            <v-col cols="4">

                 <v-select v-model="item.gra"
                    :items="api_mant_grado_tema"
                    item-text="desc_grado"
                    item-value="id"
                    label="Grado:"
                    persistent-hint
                    single-line
                    prepend-icon=""
                    ></v-select>

                <v-text-field  label="Fecha"  maxlength="80" v-model="item.fec"  @keyup.enter="doneEdit()"  @keyup.esc="cancelEdit()"  prepend-icon="border-color" required></v-text-field>

            </v-col>
            <v-col cols="4">
                <v-text-field  label="Seccion"  maxlength="80" v-model="item.sec"  @keyup.enter="doneEdit()"  @keyup.esc="cancelEdit()"  prepend-icon="border-color" required></v-text-field>
                <v-text-field  label="Hora"  maxlength="80" v-model="item.hor"  @keyup.enter="doneEdit()"  @keyup.esc="cancelEdit()"  prepend-icon="border-color" required></v-text-field>
                <v-text-field  label="Docente Encargado ( o en curso)"  maxlength="80" v-model="item.docecg"  @keyup.enter="doneEdit()"  @keyup.esc="cancelEdit()"  prepend-icon="border-color" required></v-text-field>
            </v-col> -->



        </v-row>
        <!-- <v-btn @click="addreganec();save()" class="primary fluid">Guardar <v-icon class="ml-1">fa-plus-circle</v-icon></v-btn> -->
    </div>
</v-container>
            <!--adaptando editar end -->
            <v-btn class="ma-2" @click="doneEdit()" color="primary" dark>Guardar <v-icon dark right>fas fa-plus-square</v-icon>  </v-btn>
        </div>




        <!--tabla ini-->
        <v-card v-if="btntabla">
    <div v-if="reganec.length>0">
        <v-simple-table height="auto">
    <template v-slot:default>
      <thead>
         <tr class="blue lighten-4">
          <th class="text-left">Docente</th>
          <th class="text-left">Alumno(a)</th>
          <th class="text-left">Nivel</th>
          <th class="text-left">Grado</th>
          <th class="text-left">Seccion</th>
          <th class="text-left">Fecha</th>
          <th class="text-left">Hora</th>
          <th class="text-left">Acciones</th>

        </tr>
      </thead>
      <tbody>
        <tr>

          <td><span v-html="item.doc"></span></td>
          <td><span v-html="item.nomalu"></span></td>
          <td><span v-html="item.niv"></span></td>
          <td><span v-html="item.gra"></span></td>
          <td><span v-html="item.sec"></span></td>
          <td><span v-html="item.fec"></span></td>
          <td><span v-html="item.hor"></span></td>

          <td class="text-left">
                <v-btn class="mx-2 pl-1" fab dark x-small color="warning" title="Editar" @click="edit(index)"><v-icon small >fa-edit</v-icon></v-btn>
                <v-btn class="mx-2 pl-1" fab dark x-small color="error" title="Eliminar" @click="eliminar(index)"><v-icon small >fas fa-trash</v-icon></v-btn><br><br>
                <!-- <v-btn class="mx-2 pl-1" fab dark x-small color="info" title="editar" @click="editallconten(item.id)"><v-icon small >fa-edit</v-icon></v-btn> -->
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
    </div>
    <div v-else>
          <v-alert type="warning">
            <strong>Aun no existen Registros Anecdoticos</strong>
          </v-alert>
    </div>
  </v-card>
    <!--tabla end-->

            </template>


      </div>
     <!-- </div> -->

  </v-col>
</v-row>
<!-- <v-btn color="primary pa-2" cols="auto" @click="savemirror();backmirror()" class="mt-2">Guardar <v-icon class="pl-3"></v-icon></v-btn> -->

</v-col>
</v-row>
</template>
<script>
import axios from "../../helpers/axios";
import {mapState, mapActions} from 'vuex'
  export default {
     name:'anecdoticordinador',
    data(){
       return{

        start: null,
        menu: false,
        modal: false,

        btncrear: false,
        btneditar: false,
        btntabla: true,
        btnmail:  false,

        dialog: false,
        btnallumnos: false,

        text:'',
        mensaje:false,
        task1: 'task',
        editing: false,
        variable:-1,

        reganec:[],
        nombrealumno: '',
        id_nivel:0,
        id_grado: 0,
        id_seccion: 0,
        docente:  '',
        docencargado:  '',
        fecha: '',
        hora: '',
        lugarsuceso:  '',
        descripcion:  '',
        analisis:  '',

        from_name: '',
        from_email: '',
        message: '',
        subject: '',

        api:[],

        parametros:{
          id_ano_lectivo:sessionStorage.id_ano_lectivo,
          id_colegio_adm_nivel:sessionStorage.id_colegio,
        },

        paramsProfesor:{
           id_colegio:sessionStorage.id_colegio,
           id_ano_lectivo:sessionStorage.id_ano_lectivo,
           id_profesor: 0
       },

       parametrosuser:{
           usu_usuario:sessionStorage.usu_usuario,
       },

         setreg:{

            id_ano_lectivo:sessionStorage.id_ano_lectivo,
            id_colegio:sessionStorage.id_colegio,

            id_us_ing: 6,
            //id_personal_registro:sessionStorage.usu_usuario,
            id_personal_registro: 1,
            id_personal_encargado: 1,
            id_alumno: null,
            descripcion_evento: 'guerra de comida',
            analisis_evento: 'PD: no vender mas granos en la cantina',
            id_seccion: null,
            lugar_evento: 'Recreo',
            fecha_evento: '',
            hora: '',


             },

           extralumno:{
           id_colegio:sessionStorage.id_colegio,
           id_ano_lectivo:sessionStorage.id_ano_lectivo,
           id_seccion:0
           },

           prof:{
           id_colegio:sessionStorage.id_colegio,
           id_ano_lectivo:sessionStorage.id_ano_lectivo,
           id_seccion:0,
           id_grado:0
           },


      NivelesAdmin:[],
      GradosAdmin:[],
      SeccionGrado:[],
      cursosSecciones:[],
      Profesores:[],
      Alumnos: [],
      Allistareg:[],

        }
    },

     computed: {
     ...mapState({
        Grados: state => state.nivelesGrados.grados
        //Niveles: state => state.nivelesGrados.niveles

      }),
    },

     watch: {
      dialog (val) {
        val || this.close()
      },

    },

    usuario(){ return sessionStorage;  },
    mounted(){

       this.getAllNivelesAdmin()
       this.getAllProfesores()
       this.listareganec()

    },

      methods: {

            ...mapActions('nivelesGrados',[
            'getAllGrados'
          //'getAllNiveles'
      ]),

      savereg(){

              let params = this.setreg
              axios.post('/administrativo/anecdotico', params)
              .then( response => {
              this.text = response.data.message
              this.mensaje= true
              })
              .catch( e=> console.log(e))

        },
      // actualizado ini
      //-------traer mis niveles de administracion-------
    async getAllNivelesAdmin() {
        let params = this. parametros
      try {
        let response = await axios.post("/administrativo/nivel/niveladmin/",params);
        this.NivelesAdmin = response.data;
      } catch (error) {
        console.log(error);
      }
    },
//---------traer mis grados de administracion por nivel
    async getAllGradosAdmin(id) {
      try {
        let response = await axios.get(
          "/administrativo/grado/gradosNivelAdmin/" + id + ""
        );
        this.GradosAdmin = response.data;
        console.log(this.GradosAdmin);
      } catch (error) {
        console.log(error);
      }
    },

    //----------secciones por grados ------------
    async getAllSeccionesGrados(id) {
      try {
        let response = await axios.get(
          "/administrativo/seccion/seccionGrado/" + id + ""
        );
        this.SeccionGrado = response.data;
        console.log(this.SeccionGrado);
      } catch (error) {
        console.log(error);
      }
    },

  //----------secciones por seccion  ------------
    async alumnos(id) {
      try {
        this.extralumno.id_seccion = id;
        let response = await axios.post(
          "/administrativo/seccion/secalu/fil/",this.extralumno);
        this.Alumnos = response.data;
        console.log('los alumnosss'+ JSON.stringify(this.Alumnos));
      } catch (error) {
        console.log(error);
      }
    },

    async getAllProfesores(id){
      try{
        this.prof = id
        let response = await axios.post("administrativo/asignaciondocentecurso/list/dc/",this.prof);
        this.Profesores = response.data;
        console.log('Mis profesores====api---> profesores==>>>>'+JSON.stringify(this.Profesores));
      }catch(error){
        console.log(error);
      }
    },

       async listareganec() {
        let params = this. parametros
      try {
        let response = await axios.get("/administrativo/anecdotico/",params);
        this.Allistareg = response.data;
      } catch (error) {
        console.log(error);
      }
    },

        edit(index){
          this.variable = index
          this.editing = true
          this.btneditar = true
        },

        doneEdit: function(index){
          if(! this.task1)
           { this.reganec.splice(index, 1);  }
          this.editing = false
        },

        cancelEdit: function(){
          this.editing = false
        },

         eliminar: function(index){
           this.reganec.splice(index, 1)
           //this.dialog = true
           this.estado = false
        },

         mcrear: function(){
          this.btncrear = true;
          this.btneditar = false
          this.btntabla = true
          this.btnmail = false
        },

        mcmail: function(){
          this.btncrear = false;
          this.btneditar = false
          this.btntabla = false
          this.btnmail = true
        },

        mctabla: function(){
          this.btncrear = false;
          this.btneditar = false
          this.btntabla = true
          this.btnmail = false
        },

        //## ejemplo enviar correo api ini

    //   enviar(){
    //         let data = {
    //             from_name: this.from_name,
    //             from_email: this.from_email,
    //             message: this.message,
    //             subject: this.subject,
    //         };

    //         emailjs.send("gmail","template_a1b3b7A8", data)
    //         .then(function(response) {
    //             if(response.text === 'OK'){
    //                 alert('El correo se ha enviado de forma exitosa');
    //             }
    //             console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
    //         }, function(err) {
    //             alert('Ocurrió un problema al enviar el correo');
    //             console.log("FAILED. error=", err);
    //         });
    //     },

        //## ejemplo enviar correo api end

        //## buscardor de alumnos validacion de busqueda ini
    //     querySelections (v) {
    //     this.loading = true
    //     // Simulated ajax query
    //     setTimeout(() => {
    //       this.items = this.states.filter(e => {
    //         return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
    //       })
    //       this.loading = false
    //     }, 500)
    //   },

      //## buscardor de alumnos validacion de busqueda ini


  },

}
</script>

<style scoped>

.btn-circle.btn-xl {
    width: 70px;
    height: 70px;
    padding: 10px 16px;
    border-radius: 35px;
    font-size: 24px;
    line-height: 1.33;
}

.btn-circle {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
}

:focus{
    outline: none;
}

body{
    background: #DBDBDB;
    font-family: 'Open sans';
}

/* FORMULARIO =================================== */

.form_wrap{
    width: 1050px;
    height: 530px;
    margin: 50px auto;
    display: flex;

    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
}

/* Informacion de Contacto*/

.cantact_info::before{
    content: '';
    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;
    left: 0;

    background: #4091EC;
    opacity: 0.9;
}

.cantact_info{
    width: 38%;
    position: relative;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    /*background-image: url('../fondo.jpg');*/
    background-size: cover;
    background-position: center center;

}

.info_title,
.info_items{
    position: relative;
    z-index: 2;
    color: #fff;
}

.info_title{
    margin-bottom: 60px;
}

.info_title span{
    font-size: 100px;
    display: block;
    text-align: center;
    margin-bottom: 15px;
}

.info_title h2{
    font-size: 35px;
    text-align: center;
}

.info_items p{
    display: flex;
    align-items: center;

    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
}

.info_items p:nth-child(1) span{
    font-size: 30px;
    margin-right: 10px;
}

.info_items p:nth-child(2) span{
    font-size: 50px;
    margin-right: 15px;
    margin-left: 4px;
}


/* Formulario de contacto*/
form.form_contact{
    width: 62%;
    padding: 30px 40px;
}

form.form_contact h2{
	font-size: 25px;
	font-weight: 600;
	color: #303030;
	margin-bottom: 30px;
}

form.form_contact .user_info{
    display: flex;
    flex-direction: column;
}

form.form_contact label{
    font-weight: 600;
}

form.form_contact input,
form.form_contact textarea{
    width: 100%;
    padding: 8px 0px 5px;
    margin-bottom: 20px;

    border: none;
    border-bottom: 2px solid #D1D1D1;

    font-family: 'Open sans';
	color: #5A5A5A;
	font-size: 14px;
	font-weight: 400;
}

form.form_contact textarea{
    max-width: 100%;
    min-width: 100%;
    max-height: 90px;
}

form.form_contact input[type="submit"]{
    width: 180px;
	background: #4091EC;
	padding: 10px;
	border: none;
	border-radius: 25px;

    align-self: flex-end;

    color: #fff;
	font-family: 'Open sans';
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
}

form.form_contact input[type="submit"]:hover{
    background: #3371B6;
}

/* Ventana de errores*/
.modal_wrap{
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.7);

    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;

    display: flex;
    justify-content: center;
    align-items: center;
}

.mensaje_modal{
    background: #fff;
    box-shadow: 0px 0px 15px rgba(0,0,0,0.5);
    width: 400px;
    padding: 30px 20px 15px;
}

.mensaje_modal h3{
    text-align: center;
    font-family: 'Ubuntu';
	font-size: 20px;
	font-weight: 400;
}

.mensaje_modal h3:after{
    content: '';
	display: block;
	width: 100%;
	height: 1px;
	background: #C5C5C5;
	margin: 10px 0px 15px;
}

.mensaje_modal p{
    font-size: 16px;
    color: #606060;
}

.mensaje_modal p:before{
    content: "\f00d";
    font-family: FontAwesome;
    display: inline-block;
    color: #E25151;
    margin-right: 8px;
}

#btnClose{
    display: inline-block;
	padding: 3px 10px;
	margin-top: 10px;

	background: #E25151;
	color: #fff;
	border: 2px solid #B14141;
	cursor: pointer;

	/*float: right;*/
}

/* MENSAJE EXITOSO*/

.mensaje-exito{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.mensaje-exito h1{
    font-size: 35px;
    display: block;
    text-align: center;
    margin-bottom: 20px;
}

.mensaje-exito a{
    display: block;
    padding: 10px 30px;
    background: #4091EC;
    text-decoration: none;
    color: #fff;
}

.mensaje-exito a:hover{
    background: #3371B6;
}

/* Maquetacion */

.mf1{
    padding-top: 5px;
}

.a{ background-color: brown; }


.b{ background-color: coral;

}


.c{ background-color: blueviolet; }


.d{ background-color: rgb(3, 86, 124); }

</style>